import Page from './page';
import QuickOrder from '../components/cart/quick-order';

export default class QuickOrderPage extends Page {
  private quickOrder: QuickOrder;

  constructor(body: JQuery) {
    super();
    this.quickOrder = new QuickOrder(body.find('#quickOrder'));
  }

  init(): void {
    super.init();
  }

}
